export const ACTION_PREFIX = 'LOGIN';
export const PARTITION = 'login';

export const actionTypes = {
  GENERATE_AUTH_CODE_PENDING: 'GENERATE_AUTH_CODE_PENDING',
  GENERATE_AUTH_CODE_FULFILLED: 'GENERATE_AUTH_CODE_FULFILLED',
  GENERATE_AUTH_CODE_REJECTED: 'GENERATE_AUTH_CODE_REJECTED',
  GET_TOKEN_BY_AUTH_CODE_PENDING: 'GET_TOKEN_BY_AUTH_CODE_PENDING',
  GET_TOKEN_BY_AUTH_CODE_FULFILLED: 'GET_TOKEN_BY_AUTH_CODE_FULFILLED',
  GET_TOKEN_BY_AUTH_CODE_REJECTED: 'GET_TOKEN_BY_AUTH_CODE_REJECTED',
  SET_LOGIN_STEP: 'SET_LOGIN_STEP',
};
